module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer007",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("And above all these things put on charity, which is the bond of perfectness. And let the peace of God rule in your hearts, to the which also ye are called in one body; and be ye thankful.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Colossians")]), _vm._v(" "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("3:14–15")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789f49a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bible_Verse.vue
// module id = 78
// module chunks = 0